document.querySelectorAll(".basket__fav").forEach(item => {
  item.addEventListener('click', function (e) {
    e.stopPropagation()
    e.preventDefault()
    if (this.classList.contains("basket__fav--active")) {
      this.classList.remove('basket__fav--active')
    } else {
      this.classList.add('basket__fav--active')
    }
  })
})

document.querySelectorAll(".basket__bask").forEach(item => {
  item.addEventListener("click", function (e) {
    e.stopPropagation()
    e.preventDefault()
    this.classList.remove('active')
    this.closest('.basket__btnsWr').querySelector(".basket__baskNm").classList.add('active')
    this.closest('.basket__product').classList.remove("basket__product--no")
  })
})

document.querySelectorAll(".basket__baskMin").forEach(item => {
  item.addEventListener("click", function (e) {
    e.stopPropagation()
    e.preventDefault()
    if (this.closest('.basket__baskNm').querySelector(".basket__baskCount span").textContent == 1) {
      this.closest('.basket__baskNm').classList.remove('active')
      this.closest('.basket__btnsWr').querySelector(".basket__addBt").classList.add('active')
      this.closest('.basket__product').classList.add("basket__product--no")
    } else {
      this.closest('.basket__baskNm').querySelector('.basket__baskCount span').textContent = Number(this.closest('.basket__baskNm').querySelector('.basket__baskCount span').textContent) - Number(1)
    }
  })
})

document.querySelectorAll(".basket__baskPl").forEach(item => {
  item.addEventListener("click", function (e) {
    e.stopPropagation()
    e.preventDefault()
    this.closest('.basket__baskNm').querySelector('.basket__baskCount span').textContent = Number(this.closest('.basket__baskNm').querySelector('.basket__baskCount span').textContent) + Number(1)
  })
})

document.querySelectorAll('.basket__productDel').forEach(item => {
    item.addEventListener('click', function (e) {
      e.stopPropagation()
      e.preventDefault()
      this.closest('.basket__product').classList.add('basket__product--no')
      this.closest('.basket__product').querySelector(".basket__addBt").classList.add('active')
      this.closest('.basket__product').querySelector(".basket__baskNm").classList.remove('active')
      this.closest('.basket__product').querySelector(".basket__baskCount span").textContent = 1
    })
  })

document.querySelectorAll('.basket__btnsWr').forEach(item => {
  item.addEventListener('click', function (e) {
    e.stopPropagation()
    e.preventDefault()
  })
})

document.querySelectorAll(".basket__addBt").forEach(item=>{
  item.addEventListener("click", function(e){
    this.closest(".basket__product").classList.remove('basket__product--no')
    this.classList.remove('active')
    this.closest(".basket__btnsWr").querySelector(".basket__baskNm").classList.add('active')
    
  })
})